import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import { emptyArray } from 'ui-components/default-props/empty';
import { Text, TextType } from 'ui-components/components/text';

import { USPS_PICKUP_VIEW_ID } from '../../../../components/shipping-grid/views/view-id-constants';
import messages from '../messages';
import style from '../pickup-page.module.less';

import { FormattedMessage } from 'react-intl';

const url = `/shipments/${USPS_PICKUP_VIEW_ID}`;

const UspsPickupHeader = ({ shipFroms = emptyArray }) => {
  return (
    <>
      <div className={style['pickup-header']}>
        <Text className={style['pickup-title']} textType={TextType.H3} value={<FormattedMessage {...messages.pageHeader} />} />
        <Text textType={TextType.Paragraph} value={<FormattedMessage {...messages.pageSubheader} />} />
      </div>
      <div className={style['pickup-tabs']}>
        {shipFroms.map(({ shipFromId, name }) => (
          <NavLink key={shipFromId} activeClassName={style['active-tab-link']} className={style['tab-link']} to={`${url}/${shipFromId}`}>
            {name}
          </NavLink>
        ))}
      </div>
    </>
  );
};

UspsPickupHeader.propTypes = {
  shipFroms: PropTypes.array,
};

export default UspsPickupHeader;
